import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { finalFlow, images } from '../data/content';
export function FinalCta() {
  return <section className="bg-navy px-4 py-16 sm:py-24" aria-labelledby="final-title" data-id="element-129" data-mp="19fqnhw8iprf9">
      <div className="mx-auto max-w-2xl text-center" data-id="element-130" data-mp="15d3ys4758mma">
        <h2 id="final-title" className="font-serif text-[30px] font-extrabold leading-[1.12] text-white sm:text-5xl" data-id="element-131" data-mp="15fq7461uz65k">
          Ready to Organize Your Next Rehabilitation Case With <span className="italic text-gold-light" data-id="element-132" data-mp="1edimfa7kydsy">Greater Clarity?</span>
        </h2>
        <p className="mt-5 text-[17px] leading-relaxed text-white/80" data-id="element-133" data-mp="1t1n01zrrzz4v">
          You don’t need another enormous collection of disconnected clinical information. You need a practical structure that
          helps you organize what you already know.
        </p>

        <ol className="mx-auto mt-8 flex max-w-xs flex-col items-center gap-1" data-id="element-134" data-mp="1x4ta7ii0eagm">
          {finalFlow.map((s, i) => <li key={s} className="flex w-full flex-col items-center" data-id="element-135" data-mp="n6nu779cel10" data-mpi={i}>
              <span className="w-full rounded-xl bg-navy-light px-4 py-2.5 text-[15px] font-bold text-white ring-1 ring-gold/30" data-id="element-136" data-mp="s4fkjwuc9z33">{s}</span>
              {i < finalFlow.length - 1 && <ArrowDownIcon aria-hidden="true" className="my-0.5 h-4 w-4 text-gold-light" data-id="element-137" data-mp="x5v5zq0fi7m0" />}
            </li>)}
        </ol>

        <p className="mt-8 text-[16px] text-white/80" data-id="element-138" data-mp="164qg3d6lg1ul">No complicated software. No monthly subscription. Just a practical digital toolkit.</p>

        <div className="-mx-4 mt-6 sm:mx-0" data-id="element-139" data-mp="1b1ywp9c3fxtq">
          <img src={images.mainMockup} alt="Oral Rehabilitation Blueprint full package" className="h-auto w-full" loading="lazy" data-id="element-140" data-mp="1fu9zql24rzqi" />
        </div>

        <p className="mt-4 text-xs font-bold uppercase tracking-[0.18em] text-gold-light" data-id="element-141" data-mp="1ks1ox7be57r0">Only</p>
        <p className="font-serif text-6xl font-extrabold text-white" data-id="element-142" data-mp="1ptqzklupbjek">$27 <span className="text-2xl text-gold-light" data-id="element-143" data-mp="1ttrncx3ox6ya">USD</span></p>

        <div className="mt-8 [&_p]:text-white/70" data-id="element-144" data-mp="1tryj1ogjuytg">
          <CtaButton label="Get Oral Rehabilitation Blueprint™ Now" meta="Immediate digital access · One-time payment · Lifetime access · 7-Day Guarantee" data-id="element-145" data-mp="3qtvuc4na0oc0" />
        </div>

        <div className="mt-8" data-id="element-146" data-mp="3imsqaacerap">
          <Countdown tone="dark" data-id="element-147" data-mp="3iwajal8hs5b" />
        </div>
      </div>
    </section>;
}